// extracted by mini-css-extract-plugin
module.exports = {"BoutiqueButton":"BoutiqueButton_BoutiqueButton__W_ZPD","submenu":"BoutiqueButton_submenu__AmS3K"};